import React from "react";
import PropTypes from "prop-types";

// Define TypeScript interface for props
interface GoFundMeWidgetProps {
  url: string;
  width?: string;
  maxWidth?: string;
  height?: string;
  containerClassName?: string;
}

const GoFundMeWidget: React.FC<GoFundMeWidgetProps> = ({
  url,

  maxWidth = "1000px",
  height = "447px",
  containerClassName = "",
}) => {
  return (
    <div
      className={`flex justify-center items-center w-full p-2 m-2 ${containerClassName}`}
    >
      <iframe
        src={url}
        className="gfm-embed"
        style={{ maxWidth, height }}
        title="GoFundMe Fundraiser"
        frameBorder="0"
        scrolling="yes"
      />
    </div>
  );
};

GoFundMeWidget.propTypes = {
  url: PropTypes.string.isRequired,
  width: PropTypes.string,
  maxWidth: PropTypes.string,
  height: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default GoFundMeWidget;
